import { Component, Input, OnDestroy, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { ModalController } from "@ionic/angular";
import { TranslateService } from "@ngx-translate/core";
import { Subscription } from "rxjs";
import { StaticClass } from "src/components/shared-components/class/general-classes/static-classes";
import { ConnectionType } from "src/components/shared-components/enum/enumSettings";
import { iEvent } from "src/components/shared-components/interfaces/iEvent";
import { EventService } from "src/service/event.service";
import { NetworkService } from "src/service/network.service";

@Component({
    selector: "app-week-day-choose",
    templateUrl: "./week-day-choose.component.html",
    styleUrls: ["./week-day-choose.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class WeekDayChooseComponent implements OnInit, OnDestroy, iEvent {
  @Input("disabledDays") disabledDays: number[] = [];
  @Input("singleSelection") singleSelection: boolean = false;

  /**
   * Dictionary key of the dialog title. The same dialog serves both "copy this day onto other
   * days" and "move this day", so the caller states which one it opened.
   */
  @Input("titleKey") titleKey: string = "dictionary.copy_days";

  private _translateSubscription: Subscription = null;

  public toolBarColor: string = "primary";

  private _networkServiceSubscription: Subscription = null;
  public _eventSubscriptions: Array<Subscription> = null;

  public connectionType = ConnectionType;
  public currentConnectionType: ConnectionType = ConnectionType.NONE;

  public daysSelected: any;

  public days = [
    { val: "1", name: "Lunedì", isChecked: false, isEnabled: true },
    { val: "2", name: "Martedì", isChecked: false, isEnabled: true },
    { val: "3", name: "Mercoledì", isChecked: false, isEnabled: true },
    { val: "4", name: "Giovedì", isChecked: false, isEnabled: true },
    { val: "5", name: "Venerdì", isChecked: false, isEnabled: true },
    { val: "6", name: "Sabato", isChecked: false, isEnabled: true },
    { val: "7", name: "Domenica", isChecked: false, isEnabled: true },
  ];

  constructor(
    private _modalController: ModalController,
    private _translateService: TranslateService,
    public _networkService: NetworkService,
    private _eventService: EventService
  ) { }

  ngOnInit() {
    this.loadTranslation();
    this.subscribeTranslationEvent();
    this.subscribeNetworkServiceData();
    this.subscribeEvents();
    for (let dd = 0; dd < this.disabledDays.length; dd++) {
      const index = this.days.findIndex(
        (x) => x.val === this.disabledDays[dd].toString()
      );
      this.days[index].isEnabled = false;
      this.days[index].isChecked = false;
    }
  }

  ngOnDestroy() {
    this._translateSubscription.unsubscribe();
    this._networkServiceSubscription.unsubscribe();
    this.unsubscribeEvents();
  }

  //#region Subscribe to event-service observable
  subscribeEvents(): void {
    this._eventSubscriptions = new Array<Subscription>();

    this._eventSubscriptions.push(
      this._eventService.OnMakeForceLogout.subscribe(() => {
        this._modalController.dismiss();
      })
    );
  }

  unsubscribeEvents(): void {
    for (let sub of this._eventSubscriptions) {
      sub.unsubscribe();
    }
  }
  //#endregion

  private subscribeNetworkServiceData(): void {
    this._networkServiceSubscription =
      this._networkService.currentConnectionType.subscribe(
        (currentConnectionType: ConnectionType) => {
          this.currentConnectionType = currentConnectionType;

          this.toolBarColor = StaticClass.getComponentColorByNetworkState(
            this.currentConnectionType
          );
        }
      );
  }

  /**
   * Return choosen Days: from 1-Monday to 7-Sunday
   * @param value
   */
  public onclickConfirm() {
    if (!this.singleSelection) {
      this._modalController.dismiss(
        this.days.filter((d) => d.isChecked == true).map((d) => parseInt(d.val))
      );
      return;
    }

    /* Confirming with no day picked used to dismiss [NaN]: the callers only check that the
     * selection is non-empty, so they took it for a day and drove the chart with it. */
    if (this.daysSelected === undefined || this.daysSelected === null) {
      this._modalController.dismiss();
      return;
    }

    this._modalController.dismiss([parseInt(this.daysSelected)]);
  }

  /** Close the dialog without choosing any day. */
  public onClickCancel(): void {
    this._modalController.dismiss();
  }

  //#region Translation
  public loadTranslation(): void {
    this._translateService
      .get([
        "dictionary.monday",
        "dictionary.tuesday",
        "dictionary.wednesday",
        "dictionary.thursday",
        "dictionary.friday",
        "dictionary.saturday",
        "dictionary.sunday",
      ])
      .subscribe((translation) => {
        this.days[0].name = translation["dictionary.monday"];
        this.days[1].name = translation["dictionary.tuesday"];
        this.days[2].name = translation["dictionary.wednesday"];
        this.days[3].name = translation["dictionary.thursday"];
        this.days[4].name = translation["dictionary.friday"];
        this.days[5].name = translation["dictionary.saturday"];
        this.days[6].name = translation["dictionary.sunday"];
      });
  }

  public subscribeTranslationEvent() {
    this._translateSubscription = this._translateService.onLangChange.subscribe(
      () => {
        this.loadTranslation();
      }
    );
  }

  public radioGroupChange(event) {
    this.daysSelected = event.detail.value;
  }
  //#endregion
}
